<template>
  <div :id="event.id" class="event-card" :class="{ active: isActive }" @click="handleCardClick">
    <!-- Thumbnail -->
    <div v-if="event.thumbURL" class="card-thumbnail">
      <img :src="event.thumbURL" :alt="event.title" />
    </div>

    <!-- Content -->
    <div class="card-content">
      <!-- Date range -->
      <div
        class="card-date"
        style="display: flex; justify-content: space-between;"
      >
        <span v-if="endDate">{{ startDate }} - {{ endDate }}</span>
        <span v-else>{{ startDate }}</span>
        <span v-if="primaryTag" class="tag">{{ primaryTag }}</span>
      </div>

      <!-- Title -->
      <h3 class="card-title">{{ event.title }}</h3>

      <!-- Summary/Description -->
      <p class="card-summary">{{ event.descriptionMD }}</p>

      <!-- CTA Button -->
      <div
        v-if="event.descriptionMD && event.descriptionMD.length > 0"
        class="card-cta"
      >
        <button class="btn-learn-more" @click.stop="handleCTA">
          Learn More
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import { computed } from "vue";

const props = defineProps({
  event: {
    type: Object,
    required: true
  },
  isActive: {
    type: Boolean,
    default: false
  },
  accentColor: {
    type: String,
    default: "#7c3aed"
  }
});

const emit = defineEmits(["card-selected", "cta-clicked"]);

const startDate = computed(() => {
  return props.event.startDate?.date || "Unknown";
});

const endDate = computed(() => {
  const end = props.event.endDate?.dateNum;
  if (!end || end === 0) return null;
  return props.event.endDate?.date || null;
});

const primaryTag = computed(() => {
  if (Array.isArray(props.event.theme) && props.event.theme.length > 0) {
    return props.event.theme[0];
  }
  if (typeof props.event.theme === "string" && props.event.theme.trim()) {
    return props.event.theme.trim();
  }
  return "";
});

const handleCTA = () => {
  emit("cta-clicked", props.event);
};

const handleCardClick = () => {
  emit("card-selected", props.event.id);
};
</script>

<style scoped lang="sass" src="@/assets/css/eventsExplorer.sass"></style>
